<template>
  <v-dialog v-model="open" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="400px">
    <v-card>
      <v-card-title>
        <v-layout row class="ml-1 mt-5 mb-3">
          <h2 class="headline">{{title||'Reihenfolge bearbeiten'}}</h2>
          <v-spacer></v-spacer>
          <div>
<!--            <v-btn color="primary" dark @click="orderList">Zurücksetzen</v-btn>-->
          </div>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <span class="body-1 mb-3 ml-1">Ziehe die Elemente, um ihre Reihenfolge zu verändern.</span>
        <v-list dense class="ml-n5">
          <draggable element="ul" v-model="reorderedList" :options="dragOptions" :move="onMove"
                     @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition" :name="'flip-list'">
              <v-list-item v-for="x in reorderedList" :key="x[idKey||'id']||x" style="border-bottom: 1px solid #bbbbbb;">
                <v-list-item-action style="height: 32px;">
                  <v-icon>mdi-drag</v-icon>
                </v-list-item-action>
                <v-list-item-content style="height: 32px;">
                  <v-list-item-title>
                    {{!!textKey ? x[textKey] : x}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </transition-group>
          </draggable>
        </v-list>
      </v-card-text>
      <v-card-actions class="pb-3 pr-3">
        <v-spacer></v-spacer>
        <v-btn color="silver" text @click.stop="onCancel">Abbrechen</v-btn>
        <v-btn color="primary" dark @click.stop="onOK">OK</v-btn>
      </v-card-actions>
      <div style="flex: 1 1 auto;"/>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: "DragDropListDlg",
  components: { draggable, },
  props: ['open', 'list', 'title', 'textKey', 'idKey'],
  data() {
    return {
      dlgOpen:false,
      dragOptions: {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      },
      delayedDragging:true,
      isDragging: false,
      reorderedList:[],
    };
  },
  methods: {
    onOK() {
      this.$emit('ok', this.reorderedList);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onMove({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return relatedElement;
    },
  },
  watch: {
    list: {
      immediate:true,
      handler(n) {
        this.reorderedList = [...n];
      }
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    },
  }
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: .5;
  background: #80cc28;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>